module.exports = __webpack_public_path__ + "img/Custom_Dashboard_Image.8efe704e.svg";